module.exports = __webpack_public_path__ + "static/media/podcast-cover.5220b035.jpg";